import * as React from 'react'
import { memo } from 'react'
const SvgGift = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 32 14"
  >
    <path
      fill="#fff"
      d="M2 14a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5.831a4.45 4.45 0 0 1 4.358-3 4.6 4.6 0 0 1 4 2.168 4.6 4.6 0 0 1 4-2.168 4.45 4.45 0 0 1 4.358 3H30a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2Zm28-1a1 1 0 0 0 1-1V9H16.689v4ZM1 12a1 1 0 0 0 1 1h13.689V9H1Zm30-4V5a1 1 0 0 0-1-1H16.689v4ZM15.689 8V4H2a1 1 0 0 0-1 1v3Zm7.8-5a3.52 3.52 0 0 0-3.3-2 3.52 3.52 0 0 0-3.3 2Zm-8 0a3.52 3.52 0 0 0-3.3-2 3.52 3.52 0 0 0-3.3 2Z"
      data-name="Unione 5"
    />
  </svg>
)
const Memo = memo(SvgGift)
export default Memo
